import React, { useContext } from "react"
import { ThemeContext } from "../layout"
import ProfileImage from "./ProfileImage"
import HeroWrapper from "../HeroWrapper"
import { useInView } from "react-intersection-observer"

function About(props) {
  const theme = useContext(ThemeContext)
  const [ref, inView] = useInView({
    threshold: 0.4,
    triggerOnce: true,
  })
  return (
    <HeroWrapper id="aboutme" theme={theme}>
      <div className="hero-body">
        <div className="container">
          <h1 className="title is-2">About me</h1>
          <div className="columns">
            <div className="column">
              <article className="content about-me-content">
                <p>
                  <span>Neeraj</span> is a Computer Science Engineer working as
                  a <span>front-end</span> developer based in Chennai, India.{" "}
                  During the day, he works at Teknuance as a developer. During
                  the evenings, he spends his time building on his skill set,
                  covering various aspects of front-end and back-end
                  development. He aspires to become a highly proficient{" "}
                  <span>full stack developer</span>.
                </p>
                <p>
                  He likes to keep his code <span>efficient</span>,{" "}
                  <span>clean</span> and <span>elegant</span>. He is well
                  organized and hard-working, and longs for interesting new
                  challenges and experiences.
                </p>
                <p>
                  He loves the <span>open source</span> community and aims to
                  contribute to it extensively.
                </p>
              </article>
            </div>
            <div ref={ref} className="column is-one-quarter">
              {/* <figure className="image is-1by1"> */}
              {inView && <ProfileImage />}
              {/* <img
                  className="is-rounded"
                  src={profileImage}
                  alt="neeraj profile pic"
                /> */}
              {/* </figure> */}
              {/* <h1 className="header has-text-left">About me</h1> */}
            </div>
          </div>
        </div>
      </div>
    </HeroWrapper>
  )
}

export default About
